// Utilities
import { lazy } from "react";
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
export const LazyFloatingActionButtonContainer = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "uno-fabcontainer" */ "./FloatingActionButtonContainer")).then((bundle)=>({
            default: bundle.FloatingActionButtonContainer
        })));
